import React, { useState } from "react";
import './ReportForm.css'
import "@aws-amplify/ui-react/styles.css";
// Assets
import Swal from 'sweetalert2'
import userIcon from '../Assets/person.png'
import emailIcon from '../Assets/email.png'
import issueIcon from '../Assets/issuetype.png'
import descriptionIcon from '../Assets/description.bmp'
import doctorIcon from '../Assets/doctor.png'
import countryIcon from '../Assets/countries.png'
import hospitalIcon from '../Assets/hospital.png'
import { COUNTRY_OPTIONS } from '../countriesData.js'
import surgeonslab_logo from '../Assets/surgeonslab_logo.png'
import {generateClient} from "aws-amplify/api"  
import { signUp, confirmSignUp } from "aws-amplify/auth";
import moment from 'moment'
import { createUserInfoCathView } from "../../../src/graphql/mutations";
import {createCathViewUserReports} from "../../../src/graphql/mutations";
import { useParams } from 'react-router-dom';

const ReportForm = () => {

    const { page } = useParams();
    console.log('Page:', page);

    const API = generateClient();
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [issueTitle, setIssueTitle] = useState('');
    const [Description, setDescription] = useState('');
    const [issuetype, setIssuetype] = useState('');
    // const [profession, setProfession] = useState('');
    // const [country, setCountry] = useState('');
    // const [selectedOption, setSelectedOption] = useState('');

    const reportFunc = async (e) => {
        if(username.length != 0 && email.length != 0 && issueTitle.length != 0 && Description.length != 0 && issuetype.length != 0){
            try {
                var AccountCreatedOn = moment().format('MMMM Do YYYY, h:mm:ss a')
                await API.graphql({
                query: createCathViewUserReports,
                variables: {
                input: {
                    "userMailID": email,
                    "userName": username,
                    "issue_in": issuetype,
                    "report_title": issueTitle,
                    "reportCreatedDateTime": AccountCreatedOn,
                    "description": Description
                        }
                        }
                    })
                console.log("Report submitted Successful")
                Swal.fire({
                    title: "Submitted!",
                    text: "Report submitted successfully!   ",
                    icon: "success"
                  }); 
            } catch (err) {
                Swal.fire({
                    title: "Error",
                    text: "Error submitting your report!   ",
                    icon: "error",
                    footer: err.message
                  }); 
                console.log('error submitting report: ', err)
            }  
        } else {
            Swal.fire({
                title: "Error!",
                text: "Fill in all details to continue",
                icon: "error"
            }); 
        }


    }
    
    const [action, setAction] = useState("Report Form");
    
    return (
        <div className="NavBar">
            {page === 'ReportForm' && <ReportForm />}
            <nav>
                <div className="logo">
                    <img className="logoPic" src={surgeonslab_logo} alt="SurgeonsLab Logo" />
                </div>
            </nav>

            <div className = 'container' id="form">
                <div className="header">
                    <div className="text">{action}</div>
                    <div className="underline"></div>
                </div>
                {/* <form onSubmit={handleSubmit}> */}
                <div className="inputs">
                    <div className="input">
                        <img src={userIcon} alt="User" />
                        <input type="text" placeholder="Name" id="username" value={username} onChange={(e) => setUsername(e.target.value)}/>
                    </div>
                    <div className="input">
                        <img src={emailIcon} alt="Email" />
                        <input type="email" placeholder="Email" id="email" value={email} onChange={(e) => setEmail(e.target.value)}/>
                    </div>
                    <div className="input">
                        <img src={issueIcon} alt="User" />
                        <div className="select-dropdown">
                            <select name="issuetype" value={issuetype} onChange={(e) => setIssuetype(e.target.value)}>
                                <option value="UI/UX">UI/UX</option>
                                <option value="CathView">CathView Logics</option>
                                <option value="SurgTrain">SurgTrain System</option>
                                <option value="Others">Others</option>
                            </select>
                        </div>
                    </div>
                    <div className="input">
                        <img src={descriptionIcon} alt="IssueTitle" />
                        <input type="text" placeholder="Issue Title" id="issueTitle" value={issueTitle} onChange={(e) => setIssueTitle(e.target.value)}/>
                    </div>
                    <div className="input">
                        <img src={descriptionIcon} alt="Description" />
                        <input type="text" placeholder="Description" id="Description" value={Description} onChange={(e) => setDescription(e.target.value)}/>
                    </div>
                </div> 
                
                <div className="submit-container">
                    <div className="submit" onClick={reportFunc}>Submit</div>     
                </div>

            </div>

        </div>       
    );
    
};

export default ReportForm;